<template>
  <div id="app">
    <div class="header">
      <div class="header-logo">
        <router-link to="/" class="not-router-link-active" exact>
          <img src="./img/b.svg" width="64" height="64" viewBox="0 0 64 64" fill="#fff" />
        </router-link>
      </div>
      <div class="header-nav">
        <router-link to="/works">works</router-link>
        <router-link to="/about">about</router-link>
      </div>
    </div>
    <vue-page-transition name="fade-in-right">
        <router-view />
    </vue-page-transition>
    <div class="footer">
      <ul>
        <li>
          <a href="https://dribbble.com/KOH06">Dr</a>
        </li>
        <li>
          <a href="https://www.instagram.com/vivi.koh06/">In</a>
        </li>
        <li>
          <a href="https://twitter.com/vivikoh06">Tw</a>
        </li>
      </ul>
    </div>
  </div>
  <!--#app-->
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/icon?family=Raleway|Noto+Sans+JP");
@import url("https://use.typekit.net/aiq8cmh.css");

$conceptBGC: #cdd4d4;
$sm: 544px;

@mixin sm {
  @media (max-width: ($sm)) {
    @content;
  }
}

:root {
    --transition-duration: .5s
}
* {
  box-sizing: border-box;
  ::selection {
    background: rgb(177, 255, 224);
    color: #000;
  }
  ::-moz-selection {
    background: rgb(177, 255, 224);
    color: #000;
  }
  a {
    text-decoration: none;
    color: #fff;
  }
}

body {
  margin: 0;
  //   background: rgb(0, 0, 0);
  background-color: #cdd4d4;
}

#app {
  font-family: "Raleway", Helvetica, Arial, sans-serif;
  font-weight: 800;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0 0px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.router-link-active:not(.not-router-link-active) {
  border-bottom: 1px solid #444450;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 5vh;
  margin: 0px 32px 0px 32px;
  @include sm {
    display: none;
  }
  .header-logo {
    // width: 200px;
    display: flex;
    align-items: left;
    width: 32px;
    a {
      padding-left: 5px;
      width: 100%;
      padding-top: 5px;
      img {
        max-width: 50%;
        height: auto;
      }
    }
  }
  .header-nav {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    width: 25%;
    height: 100%;
    a {
      display: block;
      width: 30%;
      font-size: 14px;
      font-weight: 800;
      padding: 8px;
      text-align: center;
      color: #fff;
    }
  }
}

.footer {
  margin-top: auto;
  margin-bottom: 0;
  height: 5vh;
  display: flex;
  align-items: center;
//   temporaly
  display:none;
  @include sm {
    display: none;
  }
  ul {
    display: flex;
    justify-content: space-between;
    width: 240px;
    padding-left: 32px;
    margin: 0;
    li {
      list-style: none;
      a {
        padding: 10px;
        color: #fff;
      }
    }
  }
}

//for mobile
.mobile-header {
  display: none;
  @include sm {
    //   background-color: #fee;
    position: relative;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 32px;
    margin: 0 16px 24px 16px;
    .mobile-header-logo-wrapper {
      height: 100%;
    }
    .mobile-header-nav {
      position: absolute;
      right: 0;
      height: 100%;
      display: flex;
      align-items: center;
      a {
        padding: 4px 8px;
        font-size: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue